import React, { useEffect } from "react";

const IntegrationFail = () => {
  const handleClose = () => {
    if (window.opener) {
      //  Send error message back to parent
      window.opener.postMessage(
        { type: "GMAIL_INTEGRATION_ERROR", payload: { status: "failed" } },
        "*" // you can replace "*" with your domain for security
      );
    }

    window.close();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center p-6 bg-white">
      <img
        src="/images/error.png"
        alt="Error"
        className="w-32 max-w-full mb-6"
      />
      <h1 className="text-2xl font-bold mb-2">Integration Failed!</h1>
      <p className="mb-6">
        There was an error during the integration. Please try again.
      </p>
      <button
        onClick={handleClose}
        className="bg-red-600 hover:bg-red-700 text-white text-base font-medium px-6 py-2 rounded-lg shadow transition"
      >
        OK
      </button>
    </div>
  );
};

export default IntegrationFail;
